module.exports = __webpack_public_path__ + "static/media/jijun.37b6095d.png";